import { IStandardAutocomplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import { formFieldKeyService } from "../../_services/formFieldKey.service";
import StandardAutoComplete from "./standard.autocomplete";

interface IStandardExtAutocomplete extends IStandardAutocomplete {
}

export const FormFieldKeyAutoComplete = (params: IStandardExtAutocomplete) => {

    return (
        <StandardAutoComplete
            {...params}
            itemsLoader={() => { return formFieldKeyService.dropdown(Number(params.parentId)) }}
            label={"Form Field Key Select"} />
    );
}